import { createActions } from 'redux-actions';

export const {
  evaluateStart,
  evaluateSuccess,
  clearEvaluation,
  appendEvaluation,
  updateEvaluation,
  updateInstanceSize,
  evaluateModelInstance,
  updateModelInstance,
  clearModelInstance
} = createActions({
  EVALUATE_START: () => undefined,
  EVALUATE_SUCCESS: () => undefined,
  CLEAR_EVALUATION: () => undefined,
  APPEND_EVALUATION: response => response,
  UPDATE_EVALUATION: response => response,
  UPDATE_INSTANCE_SIZE: payload => payload,
  EVALUATE_MODEL_INSTANCE: payload => payload,
  UPDATE_MODEL_INSTANCE: response => response,
  CLEAR_MODEL_INSTANCE: () => undefined
});



// WEBPACK FOOTER //
// ./src/actions/EvaluationActions.js